export const defaultProps = {
  name: 'Employer User Signups',
  columns: [
    { name: 'employerUserId', header: 'ID' },
    { name: 'firstName', header: 'First Name' },
    { name: 'lastName', header: 'Last Name' },
    { name: 'email', header: 'Email' },
    { name: 'employerName', header: 'Organization' },
    { name: 'selfRegisteredAt', header: 'Signed Up' },
    { name: 'status', header: 'Status' },
    { name: 'actions', header: 'Actions' },
  ],
  searchableFields: ['email', 'firstName', 'lastName', 'employerName'],
}
